import { render } from "./SSOSuccess.vue?vue&type=template&id=782ec266&scoped=true"
import script from "./SSOSuccess.vue?vue&type=script&lang=js"
export * from "./SSOSuccess.vue?vue&type=script&lang=js"

import "./SSOSuccess.vue?vue&type=style&index=0&id=782ec266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782ec266"]])

export default __exports__